<svg
    viewBox="0 0 1440 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none">
    <path d="M0 24H1440V0C722.5 52 0 0 0 0V24Z" fill="currentColor" />
</svg>
